import { useTranslation } from "react-i18next";

require('./ReloadPage.css');

export const ReloadPage = () => {
    const { t } = useTranslation();
    return (
        <div className="reload-page">
            <h1>
                { t('PAGE_CRASH') }
            </h1>
            <button
                type="button"
                className="ui primary red button"
                onClick={ () => window.location.reload() }
            >
                { t('COMMAND.REFRESH') }
            </button>
        </div>
    );
};
